function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import AddIcon from "@mui/icons-material/AddBoxRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
//Limitless imports
import { log as pilog, validateMultiWords } from "@limitless/common/utils";
import HeaderIconButton from "../buttons/header-icon-button/HeaderIconButton";
import PortalTextInput from "../form-elements/portal-text-input/PortalTextInput";
const REGEX = /^[A-Za-z0-9 _-]+$/;
const MULTILINE_ERROR = "Your entered list is not in a valid format.";
//eslint-disable-next-line
const EXAMPLE_TEXT = `Expecting: "hello", "goodbye"`;
class WordListManager extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      allSelected: false,
      selectedForDeletion: {},
      areAnySelected: false,
      currentWord: "",
      multiWordError: "",
      allowedToAdd: false,
      pastedWordList: [],
      pastedWordValidationErrors: []
    });
    _defineProperty(this, "log", pilog.getLogger("WordListManager"));
    _defineProperty(this, "handleAddWord", list => {
      const {
        name,
        onChange
      } = this.props;
      const trimmedList = list.map(item => item.trim());
      onChange({
        [name]: trimmedList
      });
      this.setState({
        pastedWordList: [],
        multiWordError: "",
        currentWord: "",
        allowedToAdd: false
      });
    });
    _defineProperty(this, "handleDeleteItem", () => {
      const {
        name,
        selectedList,
        onChange
      } = this.props;
      const {
        selectedForDeletion
      } = this.state;
      const newSelectedList = [];
      const newAvailableList = [];
      selectedList.map(selectedItem => {
        if (selectedForDeletion[selectedItem] === true) {
          newAvailableList.push(selectedItem);
        } else {
          newSelectedList.push(selectedItem);
        }
      });
      onChange({
        [name]: newSelectedList
      });
    });
    _defineProperty(this, "handleSelectAllForDelete", () => {
      const {
        selectedList
      } = this.props;
      const {
        allSelected
      } = this.state;
      if (allSelected) {
        this.setState({
          allSelected: false,
          selectedForDeletion: {}
        });
      } else {
        const selected = {};
        selectedList.map(item => {
          selected[item] = true;
        });
        this.setState({
          allSelected: true,
          selectedForDeletion: selected
        });
      }
    });
    _defineProperty(this, "handleSelectedItemCheck", item => {
      const newSelectedForDeletion = {
        ...this.state.selectedForDeletion
      };
      newSelectedForDeletion[item] = !newSelectedForDeletion[item];
      this.setState({
        selectedForDeletion: newSelectedForDeletion,
        allSelected: false
      });
    });
    _defineProperty(this, "handleWordChange", event => {
      if ((event.which === 13 || event.keyCode === 13) && event.target.value.trim()) {
        this.checkForMultiWords(event.target.value, true);
      } else if (this.props.allowAllChars && event.target.value.trim().length > 0) {
        this.checkForMultiWords(event.target.value, this.state.allowedToAdd);
      } else if (event.target.value.length === 0 || REGEX.test(event.target.value)) {
        this.checkForMultiWords(event.target.value, this.state.allowedToAdd);
      }
    });
    _defineProperty(this, "checkForMultiWords", (values, addToList = false) => {
      const {
        customWordValidator,
        multiline
      } = this.props;
      if (multiline) {
        const {
          wordList,
          hasError,
          validationErrors
        } = validateMultiWords(values, customWordValidator);
        this.setState({
          pastedWordList: wordList,
          multiWordError: hasError ? MULTILINE_ERROR : "",
          currentWord: values,
          allowedToAdd: false,
          pastedWordValidationErrors: validationErrors
        }, () => {
          if (addToList && !hasError && wordList.length !== 0) {
            this.handleAddInWordList();
          }
        });
      } else {
        this.setState({
          currentWord: values,
          multiWordError: "",
          allowedToAdd: false
        });
      }
    });
    _defineProperty(this, "handleAddInWordList", () => {
      const {
        selectedList
      } = this.props;
      const {
        currentWord,
        pastedWordList
      } = this.state;
      let newList = [...selectedList];
      if (pastedWordList.length > 0) {
        this.log.debug(pastedWordList);
        pastedWordList.forEach(word => {
          if (!selectedList.includes(word) && word.trim().length > 0) {
            newList = [...newList, word];
          }
        });
      } else {
        if (!selectedList.includes(currentWord) && currentWord.trim().length > 0) {
          newList = [...newList, currentWord];
        }
      }
      this.handleAddWord(newList);
    });
    _defineProperty(this, "renderValidationFailures", errors => {
      const components = [/*#__PURE__*/React.createElement(FormHelperText, {
        key: 0,
        error: true
      }, "The following entries failed validation:")];
      errors.map((error, index) => {
        components.push(/*#__PURE__*/React.createElement(FormHelperText, {
          error: true,
          key: index + 1
        }, error));
      });
      return components;
    });
  }
  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.selectedList.length === 0 && nextState.allSelected) {
      return {
        allSelected: false,
        areAnySelected: false,
        selectedForDeletion: {}
      };
    }
    if (!nextProps.selectedList.length !== Object.keys(nextState.selectedForDeletion).length) {
      const selectedForDeletion = {};
      let areAnySelected = false;
      nextProps.selectedList.map(item => {
        if (nextState.selectedForDeletion[item]) {
          selectedForDeletion[item] = nextState.selectedForDeletion[item];
        } else {
          selectedForDeletion[item] = false;
        }
        if (selectedForDeletion[item] === true) {
          areAnySelected = true;
        }
      });
      const newState = {
        selectedForDeletion,
        areAnySelected
      };
      //if you add a new one in and have all selected, unselect it
      if (nextState.allSelected && nextProps.selectedList.length > Object.keys(nextState.selectedForDeletion).length) {
        newState.allSelected = false;
      }
      return newState;
    }
    return null;
  }
  render() {
    const {
      classes,
      title,
      selectedTitle,
      selectedList,
      minHeight,
      error,
      helperText,
      customWordValidator,
      columnTitles,
      listLimit
    } = this.props;
    const {
      currentWord,
      selectedForDeletion,
      allSelected,
      areAnySelected,
      multiWordError,
      pastedWordValidationErrors
    } = this.state;
    let disableAddWord = currentWord !== "" ? false : true;
    if (typeof customWordValidator === "function") {
      disableAddWord = !customWordValidator(currentWord);
    }
    if (listLimit > 0 && selectedList.length === listLimit) {
      disableAddWord = true;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.addRemoveContainer,
      style: {
        minHeight
      }
    }, columnTitles && /*#__PURE__*/React.createElement("div", {
      className: classes.columnTitleContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.columnTitleLeft
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary"
    }, columnTitles.left)), /*#__PURE__*/React.createElement("div", {
      className: classes.columnTitleRight
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary"
    }, columnTitles.right))), /*#__PURE__*/React.createElement("div", {
      className: classes.selectorContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: `${classes.availableContainer} ${classes.stickyRow} ${columnTitles && classes.columnTitlePadding}`
    }, /*#__PURE__*/React.createElement(PortalTextInput, {
      id: "wordInput",
      label: title,
      onPaste: () => this.setState({
        allowedToAdd: true
      }),
      onChange: this.handleWordChange,
      onKeyPress: this.handleWordChange,
      value: currentWord,
      fullWidth: true,
      placeholder: "",
      InputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: () => {
            this.handleAddInWordList(currentWord, true);
          },
          className: disableAddWord ? classes.addButtonDisabled : classes.addButton,
          disabled: disableAddWord,
          id: "addWordButton",
          size: "large"
        }, /*#__PURE__*/React.createElement(AddIcon, {
          className: classes.addIcon
        })))
      },
      error: error || multiWordError !== "" || disableAddWord,
      helperText: helperText || multiWordError || disableAddWord && currentWord.length !== 0 && "Value not in correct format." || selectedList.length === listLimit && selectedList.length !== 0 && "Maximum list size reached.",
      disabled: listLimit > 0 && selectedList.length === listLimit
    }), multiWordError && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, EXAMPLE_TEXT), pastedWordValidationErrors.length !== 0 && this.renderValidationFailures(pastedWordValidationErrors)), /*#__PURE__*/React.createElement("div", {
      className: classes.verticalLine
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.selectedContainer,
      style: {
        minHeight: `calc(${minHeight}px - 26px)`
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: `${classes.row} ${classes.stickyRow}`
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      classes: {
        label: classes.heading,
        root: classes.headingRoot
      },
      control: /*#__PURE__*/React.createElement(Checkbox, {
        id: "selectAllCheckBox",
        value: "",
        checked: allSelected,
        onChange: this.handleSelectAllForDelete,
        checkedIcon: /*#__PURE__*/React.createElement(CheckBoxIcon, {
          color: "secondary",
          className: classes.checkboxIconSize
        }),
        icon: /*#__PURE__*/React.createElement(CheckBoxOutlineBlankIcon, {
          color: "secondary",
          className: classes.checkboxIconSize
        }),
        disabled: selectedList.length === 0
      }),
      label: /*#__PURE__*/React.createElement(Typography, null, `${selectedTitle} (${selectedList.length})`)
    }), /*#__PURE__*/React.createElement(HeaderIconButton, {
      buttonId: "removeAllButton",
      onButtonClick: this.handleDeleteItem,
      tooltip: "Delete Selected Items",
      icon: /*#__PURE__*/React.createElement(DeleteIcon, {
        className: classes.icon
      }),
      disabled: selectedList.length === 0 || !areAnySelected,
      color: "secondary"
    })), /*#__PURE__*/React.createElement("div", null, selectedList.map((item, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.row,
        key: index
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        classes: {
          root: classes.headingRoot
        },
        control: /*#__PURE__*/React.createElement(Checkbox, {
          id: `addItem${index}`,
          value: "",
          checked: selectedForDeletion[item],
          onChange: () => this.handleSelectedItemCheck(item),
          checkedIcon: /*#__PURE__*/React.createElement(CheckBoxIcon, {
            color: "secondary",
            className: classes.checkboxIconSize
          }),
          icon: /*#__PURE__*/React.createElement(CheckBoxOutlineBlankIcon, {
            color: "secondary",
            className: classes.checkboxIconSize
          })
        }),
        label: /*#__PURE__*/React.createElement(Typography, null, item)
      }));
    })))));
  }
}
const styles = theme => ({
  columnTitleContainer: {
    display: "flex",
    width: "100%"
  },
  columnTitleLeft: {
    display: "flex",
    flexBasis: "50%"
  },
  columnTitleRight: {
    display: "flex",
    flexBasis: "50%",
    marginLeft: 35
  },
  addRemoveContainer: {
    display: "flex",
    flex: 1,
    marginTop: 32,
    flexDirection: "column"
  },
  headingRoot: {
    width: "100%"
  },
  heading: {
    color: theme.palette.contrast.text,
    fontSize: 12,
    fontWeight: 700
  },
  selectorContainer: {
    display: "flex",
    flex: 1,
    maxHeight: 350,
    overflow: "auto"
  },
  availableContainer: {
    flexBasis: "50%",
    height: "100%"
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: theme.palette.border
  },
  verticalLine: {
    width: 3,
    backgroundColor: "rgba(0,0,0,0.2)",
    borderRadius: 10,
    marginLeft: 44,
    marginRight: 32,
    position: "sticky",
    top: 0,
    marginTop: 22
  },
  selectedContainer: {
    flexBasis: "50%",
    marginRight: 8,
    border: theme.palette.border,
    padding: 16,
    marginTop: 22,
    height: "100%",
    borderRadius: 4
  },
  stickyRow: {
    position: "sticky",
    top: 0,
    backgroundColor: theme.background.paper,
    zIndex: 2
  },
  icon: {
    fontSize: 26
  },
  addButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 50,
    padding: 8,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark
    }
  },
  addButtonDisabled: {
    backgroundColor: theme.palette.contrast.main,
    borderRadius: 50,
    padding: 8
  },
  addIcon: {
    color: theme.palette.primary.contrastText
  },
  columnTitlePadding: {
    paddingTop: 18
  }
});
export default withStyles(styles)(WordListManager);
WordListManager.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  selectedTitle: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedList: PropTypes.array.isRequired,
  minHeight: PropTypes.number.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  allowAllChars: PropTypes.bool,
  multiline: PropTypes.bool,
  customWordValidator: PropTypes.func,
  columnTitles: PropTypes.object,
  listLimit: PropTypes.number
};
WordListManager.defaultProps = {
  minHeight: 300,
  error: false,
  allowAllChars: false,
  multiline: false,
  selectedList: [],
  columnTitles: null,
  listLimit: 0
};